export default function (v1, v2, options) {
    if (v1.length>v2) {
        return options.fn(this);
    }
    return options.inverse(this);
};
